import React from "react";
import Login from "../pages/Auth/Login";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import SetPassword from "../pages/Auth/SetPassword";
import EmailVerification from "../pages/Auth/EmailVerify";
import { Navigate, useRoutes } from "react-router-dom";
import ChangePassword from "../pages/Auth/ChangePassword";
import CoupleUpdate from "../pages/Common/CoupleUpdate";
import ThankYou from "../pages/Common/ThankYou";
import { RegistrationRetreat } from "../pages/Auth/RegistrationRetreat";
import VerifiedThankYou from "../pages/Auth/VerifiedThankYou";
import Directory from "../pages/Auth/Directory";
import Program from "../pages/Auth/Program";
import ProjectedRetreatForm from "../pages/Admin/Retreats/ProjectedRetreatForm";
import CreateTicket from "../pages/TicketSystem/CreateTicket";
import TicketReply from "../pages/TicketSystem/TicketReply";
import UpcomingRetreats from "../pages/Auth/UpcomingRetreats";
import { RegisterWaitList } from "../pages/WaitList/RegisterWaitList";
import type { AuthRouterProps } from "../types/layout";

const AuthRouter = ({ updatedUser }: AuthRouterProps): React.ReactElement => {
  const route = useRoutes([
    { path: "/login", element: <Login updatedUser={updatedUser} /> },
    { path: "/forgetPassword", element: <ForgotPassword /> },
    { path: "/set-password", element: <SetPassword /> },
    { path: "/changePassword", element: <ChangePassword /> },
    { path: "/email-verification", element: <EmailVerification /> },
    { path: "/couple-update/:coupleId", element: <CoupleUpdate /> },
    { path: "/registration-retreat", element: <RegistrationRetreat /> },
    { path: "/thankyou", element: <ThankYou /> },
    { path: "/verified-thank-You", element: <VerifiedThankYou /> },
    { path: "/directory/:id", element: <Directory /> },
    { path: "/program/:id", element: <Program /> },
    { path: "/registration-retreat/:id", element: <RegistrationRetreat /> },
    { path: "/retreats/project", element: <ProjectedRetreatForm /> },
    { path: "/register-new-retreat", element: <Navigate to="/retreats/project" replace /> },
    { path: "/create-ticket", element: <CreateTicket /> },
    { path: "/ticketReply/:id", element: <TicketReply /> },
    { path: "/upcoming-retreats", element: <UpcomingRetreats /> },
    { path: "/register-waitList/:id", element: <RegisterWaitList /> },
    { path: "/*", element: <Navigate to="/login" /> },
  ]);
  return <>{route}</>;
};
export default AuthRouter;
